import * as React from 'react';
import { emptyFn } from '../utilities';
import { getBorderFromProps } from '../Input/utils';
import { getProp } from '@sportnet/utilities';
import { rem } from 'polished';
import FormGroupContext from '../FormGroup/FormGroupContext';
import styled from 'styled-components';
const Select = styled('select') `
  width: 100%;
  height: ${({ theme }) => rem(theme.input.height)};
  border-radius: ${({ theme }) => rem(theme.input.borderRadius)};
  font-size: ${({ theme }) => rem(theme.input.fontSize)};
  padding: 0 ${({ theme }) => rem(theme.input.horizontalPadding)};
  color: ${({ theme }) => theme.textColor};
  font-family: ${({ theme }) => theme.fontFamily};
  outline: 0;
  background-color: ${({ theme }) => theme.input.backgroundColor};
  box-shadow: ${({ theme }) => theme.input.shadow};
  border: ${props => getBorderFromProps(props)};
  &::placeholder {
    color: ${({ theme }) => theme.form.placeholderColor};
  }
  &:read-only {
    cursor: ${({ theme }) => theme.input.readOnlyCursor};
  }
  &:disabled {
    -webkit-text-fill-color: ${({ theme }) => theme.input.disabledTextColor};
    background-color: ${({ theme }) => theme.input.disabledBackground};
    cursor: ${({ theme }) => theme.input.disabledCursor};
  }
  &:focus {
    border: ${props => getBorderFromProps({ ...props, $focused: true })};
  }

  padding-right: ${rem(21)};
`;
const Wrapper = styled.div `
  position: relative;
`;
const CompSelect = ({ className = '', children, createUnknownOption = true, value, id = null, inputRef = emptyFn, ...restProps }) => {
    const iterateOptions = (options, value) => {
        let exists = false;
        if (Array.isArray(options)) {
            exists = options.some(option => {
                return iterateOptions(option, value);
            });
        }
        else if (getProp(options, ['props', 'value']) === value) {
            exists = true;
        }
        return exists;
    };
    const renderOptions = () => {
        if (!createUnknownOption || !value) {
            return children;
        }
        let option = null;
        const exists = iterateOptions(children, value);
        if (!exists) {
            option = React.createElement("option", { value: value }, value);
        }
        return [option, ...children];
    };
    return (React.createElement(FormGroupContext.Consumer, null, value => (React.createElement(Wrapper, { className: className },
        React.createElement(Select, { ...restProps, ref: inputRef, id: id || value.id }, renderOptions())))));
};
export default CompSelect;
